import { CircularProgress } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ROUTES } from "src/routes/ROUTES";

const LoginCallback = () => {
  const auth = useAuth();
  const location = useLocation();

  const from =
    (location.state as { from?: Location })?.from?.pathname || ROUTES.ROOT;

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      localStorage.setItem("auth-token", auth.user.access_token);
    }
  }, [auth.isAuthenticated, auth.user]);

  if (auth.isLoading) {
    return <CircularProgress />;
  }

  if (auth.error) {
    console.error(auth.error);
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  if (auth.isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return null;
};

export default LoginCallback;
